import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'barte-design-system';

import styles from './test-failure-modal.module.css';
import type { TestFailureModalProps } from './test-failure-modal.type';

export const TestFailureModal = ({
  isOpen,
  isLoading = false,
  onConfirm,
  onClose,
}: TestFailureModalProps) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(reason.trim());
  };

  return (
    <Modal
      isOpen={isOpen}
      size="sm"
      title={t('backoffice.terminalTestFailureModalTitle')}
      onClose={isLoading ? () => {} : handleClose}
      footer={{
        buttonLayout: 'hug',
        secondaryButton: {
          children: t('backoffice.terminalsWizardCancel'),
          variant: 'outline',
          onClick: handleClose,
          disabled: isLoading,
        },
        primaryButton: {
          children: t('backoffice.terminalTestFailureModalConfirm'),
          onClick: handleConfirm,
          disabled: isLoading || reason.trim().length === 0,
        },
      }}
    >
      <p className={styles.description}>
        {t('backoffice.terminalTestFailureModalDescription')}
      </p>
      <textarea
        className={styles.textarea}
        placeholder={t('backoffice.terminalTestFailureModalPlaceholder')}
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        disabled={isLoading}
      />
    </Modal>
  );
};
